import { createModalStore } from '@/shared/lib/modal';

type RecordingExtensionPromptStep = 'install' | 'pin';

/**
 * Who asked for the prompt; also its analytics `source`. 'new_recording' is the automatic offer on a new recording,
 * shown at most once per user. 'records_banner' is the user's own click on the Records page banner: it is shown every
 * time and does not spend the once-per-user flag.
 */
export type RecordingExtensionPromptSource = 'new_recording' | 'records_banner';

type RecordingExtensionPromptState = {
  // Set when the prompt stands in for the recorder on the first "new recording": leaving it opens the recorder.
  continueToRecorder: boolean;
  source: RecordingExtensionPromptSource;
  step: RecordingExtensionPromptStep;
};

// `open()` requests the prompt; the modal itself decides whether it may be shown (desktop Chromium, and for the
// automatic offer, not shown before).
export const useRecordingExtensionPromptStore = createModalStore<RecordingExtensionPromptState>({
  continueToRecorder: false,
  source: 'new_recording',
  step: 'install',
});
